import styled, { css } from 'styled-components';

import { Modal } from '@speeki/global-ui-components';

export const ModalHeader = styled(Modal.Header)`
    margin-bottom: 16px;
`;

export const PrivacyLink = styled.a`
    ${({ theme: { palette } }) => css`
        color: ${palette.tertiary.default};

        p {
            color: ${palette.tertiary.default};
            display: inline;
        }
    `}
`;

export const ModalList = styled.ul`
    margin: 0;
    padding: 0 0 0 20px;
`;

export const ListItem = styled.li`
    padding-bottom: 8px;
    text-align: left;

    &:last-child {
        padding-bottom: 0;
    }
`;
